import React from "react";
import ReactDOM from "react-dom";

const Fullscreenloader = () => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
    </div>,
    document.body
  );
};

export default Fullscreenloader;
